import { type SnmpCommandFactory, prepareDataForSnmpForm } from '../SnmpModel';
import { getSnmp } from './api/getSnmp';

export const loadSnmp: SnmpCommandFactory<void> = (cmdContext) => async () => {
  try {
    cmdContext.updateState((draft) => {
      draft.loading = true;
    });

    const response = await getSnmp(cmdContext.api);
    const data = prepareDataForSnmpForm(response.snmp);

    cmdContext.updateState((draft) => {
      draft.values = data;
    });
  } finally {
    cmdContext.updateState((draft) => {
      draft.loading = false;
    });
  }
};
